export const API_PATH_ApiDeviceMgmtRegionCreate = '/services/devices-mgtm/apiDeviceMgmtRegionCreate';
